import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { blogPosts } from "@/i18n/blogPosts";
import ScrollReveal from "@/components/ScrollReveal";
import BlogHero from "@/components/hero/BlogHero";

const Blog = () => {
  const { t, lang } = useLang();

  return (
    <main data-testid="blog-page" className="bg-brand-bg text-white pt-32">
      <BlogHero />

      <section className="py-20 md:py-28 border-b border-brand-border">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {blogPosts.map((p, i) => (
            <ScrollReveal
              key={p.slug}
              delay={i * 80}
              as="article"
              className="group rounded-2xl border border-brand-border bg-brand-surface/60 hover:bg-brand-surface transition-colors bento-cell card-glow overflow-hidden"
            >
              <Link to={`/blog/${p.slug}`} data-testid={`blog-card-${p.slug}`} className="block">
                <div className="aspect-[16/10] overflow-hidden relative">
                  <img src={p.image} alt={p.title[lang]} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/80 to-transparent" />
                </div>
                <div className="p-6 md:p-8">
                  <div className="flex items-center gap-3 text-[10px] font-mono uppercase tracking-[0.25em] text-zinc-500 mb-4">
                    <span className="text-brand-purpleLight">{p.cat[lang]}</span>
                    <span>•</span>
                    <span>{p.time[lang]}</span>
                  </div>
                  <h3 className="font-heading text-xl md:text-2xl font-bold leading-snug mb-3 group-hover:text-white transition-colors">
                    {p.title[lang]}
                  </h3>
                  <p className="text-sm text-zinc-400 leading-relaxed mb-6">{p.excerpt[lang]}</p>
                  <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-zinc-300 group-hover:text-brand-purpleLight transition-colors">
                    {t.blog.readMore}
                    <ArrowUpRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            </ScrollReveal>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Blog;
